export default class ShuffleTxt {
    constructor() {
        this.$shuffleTxts = [...document.querySelectorAll('.js-shuffleTxt')];
        this.$spans = [];
        this.txts = [];

        this._init();
    }

    _init() {
        this._initShuffleTxt();
    }

    _initShuffleTxt() {
        this.$shuffleTxts.forEach(($shuffleTxt, i) => {
            this.$spans[i] = [];
            this.childNodes = [...$shuffleTxt.childNodes];
            this.txts[i] = $shuffleTxt.textContent;

            $shuffleTxt.replaceChildren();
            this._appendSpan($shuffleTxt, i);
        });
    }

    _appendSpan($wrapper, i) {
        for (const node of this.childNodes) {
            if (node.nodeType == Node.TEXT_NODE) {
                for (let j = 0; j < node.textContent.length; j++) {
                    const $span = document.createElement('span');
                    this.$spans[i].push($span);
                    $wrapper.appendChild($span);
                }
            } else if (node.nodeType == Node.ELEMENT_NODE) {
                this.childNodes = [...node.childNodes];
                node.replaceChildren();
                $wrapper.appendChild(node);
                this._appendSpan(node, i);
            }
        }
    }

    setObserve() {
        const delay = 80;
        const delayRange = [4000, 6000];
        const options = { rootMargin: '0px 0px -20%' };

        this.$shuffleTxts.forEach(($shuffleTxt, i) => {
            const callback = entries => {
                if (!entries[0].isIntersecting || $shuffleTxt.classList.contains('-reveal')) return;
                $shuffleTxt.classList.add('-reveal');
                repeatShuffle();
            };

            const repeatShuffle = () => {
                const randomDelay = Math.floor(Math.random() * (delayRange[1] + 1 - delayRange[0])) + delayRange[0];
                this.$spans[i].forEach(($span, j) => {
                    setTimeout(() => this._shuffleOneChara($span, i, j), delay * j);
                });
                setTimeout(() => repeatShuffle(), randomDelay);
            };

            const intersection = new IntersectionObserver(callback, options);

            intersection.observe($shuffleTxt);
        });
    }

    _shuffleOneChara($span, i, j) {
        const exclude = ['.', '-', '\u00A0'];
        const count = 20;
        const delay = 20;
        let txtIndex = 0;

        if (exclude.includes(this.txts[i][j])) {
            $span.textContent = this.txts[i][j];
            return;
        }

        for (let k = 0; k < count; k++) {
            setTimeout(() => {
                // フォントファミリーをランダムで設定
                const fontNum = Math.floor(Math.random() * 2);
                $span.className = fontNum ? 'c-font-silkscreen' : '';

                // コンマ、ハイフン、空白はシャッフルから除外する
                do {
                    txtIndex = Math.floor(Math.random() * this.txts[i].length);
                } while (exclude.includes(this.txts[i][txtIndex]));

                // 一文字をランダムで設定し、正しい文字は最後のカウントで設定
                if (k >= count - 1) txtIndex = j;
                $span.textContent = this.txts[i][txtIndex];
            }, delay * k);
        }
    }
}
